import { reactive } from "vue";

export const invoiceState = reactive({
  currentInvoiceId: undefined,
  currentMiddleColView: "preview",
  isUnSaved: false,
});
